import type { Formatter, LogEntry } from "../types";

export class DefaultFormatter implements Formatter {
	format(entry: LogEntry): string {
		const timestamp = entry.timestamp.toISOString();
		const prefix = entry.prefix ? `[${entry.prefix}]` : "";
		const metadata = entry.metadata ? ` ${JSON.stringify(entry.metadata)}` : "";
		return `${timestamp} ${prefix} [${entry.level.toUpperCase()}] ${entry.message}${metadata}`;
	}
}

export function createFormatter(): Formatter {
	return new DefaultFormatter();
}
